import { getNestedSubelementsByType, getMostRecentFieldValue } from '@fs/zion-sls'

/**
 * Extracts primary event information from a record
 * @param {Object} record - The record element
 * @returns {Object} Primary event details
 */
export const getRecordPrimaryEventData = (record) => {
  const recordEvents = getNestedSubelementsByType(record, 'EVENT') || []
  const primaryEvent = recordEvents.find((ev) => ev?.primary)

  const date = getNestedSubelementsByType(primaryEvent, 'DATE', true)?.[0]
  const place = getNestedSubelementsByType(primaryEvent, 'PLACE', true)?.[0]

  return {
    event: primaryEvent,
    date: getMostRecentFieldValue(date),
    place: getMostRecentFieldValue(place),
  }
}

/**
 * Formats record display data as a string
 * @param {Object} record - The record element
 * @returns {string} Formatted record data (e.g., "Birth | 1850 | New York")
 */
export const formatRecordDisplayData = (record) => {
  const typeLabel = record?.displayLabel ?? record?.label
  // When creating new records, the default type is "RECORD" which is not informative to display, so we omit it
  const typeLabelToDisplay = typeLabel !== 'RECORD' ? typeLabel : null
  const { date, place } = getRecordPrimaryEventData(record)

  return [typeLabelToDisplay, date, place].filter(Boolean).join(' | ')
}
